const GA_EVENT_AUTH = {
  LOGIN_OR_SIGNUP: "auth.login_or_signup",
  KAKAO: "auth.kakao",
  GOOGLE: "auth.google",
  APPLE: "auth.apple",
  EMAIL: "auth.email",
};

const GA_EVENT_PROFILE = {
  NEW_PROFILE: "profile.new_profile_create",
  EDIT_PROFILE: "profile.profile_edit",
  HOST_CREATE: "event.profilehost.start_create",
};

const GA_EVENT_EVENT = {
  HOST_START_CREATE: "event.host.start_create",
  HOST_FINISH_CREATE: "event.host.finish_create",
  HOST_START_DELETE: "event.host.start_delete",
  HOST_FINISH_DELETE: "event.host.finish_delete",
  GUEST_JOIN: "event.guest.join",
  GUEST_SHARE: "event.guest.share",
  GUEST_START_LEAVE: "event.guest.start_leave",
  GUEST_FINISH_LEAVE: "event.guest.finish_leave",
};

const GA_EVENT_MODAL_POPUP = {
  VOTE_CLICK: "modalpop.user.vote",
  VOTE_CLOSE: "modalpop.user.vote_close",
};

export const GA_EVENT_IDS = {
  AUTH: GA_EVENT_AUTH,
  PROFILE: GA_EVENT_PROFILE,
  EVENT: GA_EVENT_EVENT,
  MODAL_POPUP: GA_EVENT_MODAL_POPUP,
};
